// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-cv-index-js": () => import("./../../../src/templates/CV/index.js" /* webpackChunkName: "component---src-templates-cv-index-js" */),
  "component---src-templates-work-index-js": () => import("./../../../src/templates/Work/index.js" /* webpackChunkName: "component---src-templates-work-index-js" */)
}

